export default '0.0.194';
//# sourceMappingURL=version.js.map